import React, { Fragment, useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import Pagination from "react-js-pagination";
import AppContext from '../../../contexts/AppContext'
import Breadcrumbs from '../../Breadcrumbs'
import Header from '../../Header'
import Footer from '../../Footer'
import { breadcrumbsBy } from '../../../services/locations'
import { searchProperty, searchFromHash, setEncoded, getEncoded } from '../../../services/search'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

import useToastContext from "../../../hooks/useToastContext";

import moment from "moment"

import { Helmet } from "react-helmet-async";

import { Modal } from '../../UI'

const LeadsList = ({ match, history }) => {

    const { data, leadServices } = useContext(AppContext)
    const { app, isReady } = data
    const { user } = app

    const [ loading, setLoading ] = useState(false)
    const [ deleting, setDeleting ] = useState(null)
    const [ updating, setUpdating ] = useState(null)
    const [ search, setSearch ] = useState({})
    const [ list, setList ] = useState({})
    const [ searchActive, setSearchActive ] = useState(false)

    const [ showDialog, setShowDialog ] = useState(false)
    const [ dialogOptions, setDialogOptions ] = useState({})

    const modalDialog = (options) => {
        return new Promise((resolve, reject) => {
            options.onButtonClick = button => {
                if(['cancel', 'close'].includes(button)){
                    setShowDialog(false)
                    reject()
                }
                if(['delete'].includes(button)){
                    setShowDialog(false)
                    resolve()
                }
            }
            options.show = showDialog
            setDialogOptions(options)
            setShowDialog(true)
        })
    }

    const loadPoints = () => {
        return new Promise((resolve, reject) => {
            setLoading(true)
            setSearch(searchFromHash())
            leadServices.list(getEncoded()).then(res => {
                setList(res.leads)
                setLoading(false)
                setSearchActive(false)
                resolve()
            }).catch(res => {
                if(res.status == 403) history.push("/unauthorized")
                if(res.status == 404) history.push("/page-not-found")
                if(res.status == 500) history.push("/server-error")
                reject()
            })
        })
    }

    const deleteLead = id => {
        return new Promise((resolve, reject) => {
            setDeleting(id)
            leadServices.delete(id).then(res => {
                setDeleting(null)
                loadPoints()
            }).catch(res => {
                if(res.status == 404) history.push("/page-not-found")
                if(res.status == 500) history.push("/server-error")
                reject()
            })
        })
    }

    useEffect(() => {
        if(isReady) loadPoints()
    }, [ history.location.hash, isReady ])

    const setSearchProperty = (type, value) => {
        const res = searchProperty(search, type, value)
        setSearch(res.search)
        if(!res.isEqual) setSearchActive(true)
        return res.search
    }

    const onSearch = newSearch => {
        setEncoded(newSearch ? newSearch : {... search})
    }

    const changePage = page => {
        setEncoded(setSearchProperty('page', page == 1 ? null : page))
    }


    const capitalize = s => { if (typeof s !== 'string') return ''; return s.charAt(0).toUpperCase() + s.slice(1) }

    const title = "Leads"

    return (
        <Fragment>
            <div className="d-flex justify-content-between mt-3">
                <div className="d-flex d-flex flex-wrap mt-4 mb-2 justify-content-between w-100">
                    <h1 className="h2">{title}</h1>
                    <div>

                        <form
                            className="input-group mb-3"
                            onSubmit={e => {
                                e.preventDefault()
                                onSearch()
                            }}
                        >
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search"
                                aria-label="Search"
                                aria-describedby="lead-search-button"
                                value={search.query ? search.query : ''}
                                onChange={e => {
                                    setSearchProperty('query', e.target.value)
                                }}
                            />
                            <div className="input-group-append">
                                <button
                                    className={"btn " + (searchActive ? 'btn-primary' : "btn-outline-secondary")}
                                    type="submit"
                                    id="lead-search-button"
                                    onClick={() => onSearch()}
                                >Search</button>
                            </div>
                        </form>

                    </div>
                    <div className="d-flex">
                        {list.data && list.data.length > 0 && list.last_page > 1 &&
                            <nav>
                                <Pagination
                                    activePage={search.page}
                                    itemsCountPerPage={parseInt(list.per_page)}
                                    totalItemsCount={list.total}
                                    pageRangeDisplayed={5}
                                    onChange={changePage}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    prevPageText="Previous"
                                    nextPageText="Next"
                                    hideFirstLastPages={true}
                                />
                            </nav>
                        }
                        <div className="ms-3">
                            <Link tag="a" to="/account/leads/create" className="btn btn-success">Create lead</Link>
                        </div>
                    </div>
                </div>

            </div>

            {loading && <FontAwesomeIcon icon={faSpinner} />}

            {!loading && list.data && list.data.length == 0 &&
                <p className="lead">
                    There are no leads here yet. Go ahead and <Link tag="a" to="/account/leads/create">create a new lead</Link>.
                </p>
            }

            {!loading && list.data && list.data.length > 0 &&
                <Fragment>
                    <div className="table-responsive">
                        <table className="table table-striped table-bordered bg-white">
                            <thead>
                                <tr>
                                    <th className="text-center">#</th>
                                    <th className="text-left">Contact Name</th>
                                    <th className="text-center">Company</th>
                                    <th className="text-center">Phone</th>
                                    <th className="text-center">Email</th>
                                    <th className="text-center">Status</th>
                                    <th className="text-center">Signed-up</th>
                                    <th className="text-center">Created</th>
                                    <th className="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {list.data.map(item => {
                                    const salutation = item.salutation ? (capitalize(item.salutation) + '. ') : ''
                                    return (
                                        <tr key={item.id}>
                                            <td className="text-center align-middle">{item.id}</td>
                                            <td className="text-left align-middle">
                                                {salutation}{item.name}
                                            </td>
                                            <td className="text-left align-middle">
                                                {item.company}
                                            </td>
                                            <td className="text-left align-middle">{item.phone}</td>
                                            <td className="text-left align-middle">{item.email}</td>
                                            <td className={
                                                'text-center align-middle ' + (
                                                    item.status == 'new' ? ' bg-white' :
                                                    item.status == 'contacted' ? 'bg-secondary text-white' :
                                                    item.status == 'working' ? 'bg-primary text-white' :
                                                    item.status == 'qualified' ? 'bg-success text-white' :
                                                    item.status == 'unqualified' ? 'bg-light text-muted' : ''
                                                )
                                            }>{item.status}</td>
                                            <td className="text-center align-middle">
                                                {item.affiliate ? (
                                                    <span className={!item.affiliate.active ? 'text-muted' : ''}>{item.affiliate.full_name}</span>
                                                ) : '-'}
                                            </td>
                                            <td className="text-center align-middle">{moment(item.created_at).format('MM/DD/YY hh:mm a')}</td>
                                            <td className="text-center align-middle">
                                                <Link tag="a" className="mx-1" to={'/account/leads/view/' + item.id}>View</Link>
                                                <Link tag="a" className="mx-1" to={'/account/leads/edit/' + item.id}>Edit</Link>
                                                <a href=""
                                                    className="mx-1 text-danger"
                                                    onClick={e => {
                                                        e.preventDefault()
                                                        modalDialog({
                                                            title: 'Confirm',
                                                            description: 'Are you sure want to delete the lead #' + item.id + '?',
                                                            buttons: ['cancel', 'delete'],
                                                            size: 'md'
                                                        }).then(() => deleteLead(item.id)).catch(res => {})
                                                    }}
                                                >
                                                    Delete
                                                </a>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>

                    {list.data && list.data.length > 0 && list.last_page > 1 &&
                        <nav>
                            <Pagination
                                activePage={search.page}
                                itemsCountPerPage={parseInt(list.per_page)}
                                totalItemsCount={list.total}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                                itemClass="page-item"
                                linkClass="page-link"
                                prevPageText="Previous"
                                nextPageText="Next"
                                hideFirstLastPages={true}
                            />
                        </nav>
                    }
                </Fragment>
            }
            <Modal {...dialogOptions} show={showDialog} />
        </Fragment>
    )
}

const LeadsSummary = ({ }) => {

    const { data, leadServices } = useContext(AppContext)
    const { app, isReady } = data

    const [ loading, setLoading ] = useState(false)
    const [ summary, setSummary ] = useState(null)

    const loadSummary = () => {
        return new Promise((resolve, reject) => {
            setLoading(true)
            leadServices.summary().then(res => {
                setSummary(res.summary)
                setLoading(false)
                resolve()
            }).catch(res => {
                if(res.status == 404) history.push("/page-not-found")
                if(res.status == 500) history.push("/server-error")
                reject()
            })
        })
    }

    useEffect(() => {
        if(isReady) loadSummary()
    }, [ isReady ])

    return (
        <div className="card h-100">
            {summary &&
                <div className="card-body"><table className="table table-sm table-hover mb-0">
                    <tbody>
                        <tr>
                            <td className="">New leads</td>
                            <td className="text-right">{summary.new}</td>
                        </tr>
                        <tr>
                            <td className="">Contacted</td>
                            <td className="text-right">{summary.contacted}</td>
                        </tr>
                        <tr>
                            <td className="">Working</td>
                            <td className="text-right">{summary.working}</td>
                        </tr>
                        <tr>
                            <td className="">Qualified</td>
                            <td className="text-right">{summary.qualified}</td>
                        </tr>
                        <tr>
                            <td className="">Unqualified</td>
                            <td className="text-right">{summary.unqualified}</td>
                        </tr>
                        <tr>
                            <th className="">Total number of leads</th>
                            <th className="text-right">{summary.total}</th>
                        </tr>
                    </tbody>
                </table></div>
            }
            {loading &&
                <div className="card-body m-5 text-center">
                    <FontAwesomeIcon icon={faSpinner} spin />
                </div>
            }
        </div>
    )

}

const Index = ({ match, history }) => {

    const { data, location } = useContext(AppContext)
    const { app } = data
    const { user } = app

    const title = "Leads & sales"

    return (
        <Fragment>
            <div>
                <Header history={history} />
                <main className="py-4">
                    <div className="container">

                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {title}])} />

                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        <h1>{title}</h1>

                        <div className="row">
                            <div className="col-lg-4">
                                <LeadsSummary />
                            </div>
                            <div className="col-lg-4">
                                {user?.promo_str ? (
                                    <div className="mb-2">
                                        Promo Code: <b>{user.promo_str}</b>
                                    </div>
                                ) : (
                                    <div className="mb-2">
                                        Promo code is not set. Please contact administrator.
                                    </div>
                                )}
                                <div className="mb-2">
                                    <a href={`/api/user/${user.id}/qr-code`} target="_blank"><img src={`/api/user/${user.id}/qr-code`} alt="" /></a>
                                </div>
                            </div>
                        </div>

                        <LeadsList
                            match={match}
                            history={history}
                        />

                    </div>
                </main>
            </div>
            <Footer />
        </Fragment>
    )
}

export default Index
